/* ms-lieferzeit-alternativen  ·  v7  ·  2026-08-06

   Anzeigelogik:
   1. Schnellere Farben desselben Bettes in der gewaehlten Groesse
   2. zusaetzlich EIN Ersatzmodell, wenn es die gewaehlte Farbe kurzfristig hat
   3. gibt es gar keine schnelle Farbe: bis zu drei Ersatzmodelle, Wunschfarbe zuerst

   Wichtig fuer kuenftige Aenderungen: markSwatches() schreibt in den vom
   MutationObserver beobachteten Teilbaum. Attribute deshalb nur bei echter
   Wertaenderung anfassen und den Observer waehrenddessen pausieren - sonst
   triggert der Block sich selbst und baut die Box im Dauerlauf neu auf, was
   Klicks und :hover unmoeglich macht. */

if (!customElements.get('ms-lieferzeit-alternativen')) {
  customElements.define('ms-lieferzeit-alternativen', class extends HTMLElement {
    connectedCallback() {
      var quelle = this.querySelector('[data-ms-lz-data]');
      if (!quelle) return;
      try { this.data = JSON.parse(quelle.textContent); } catch (e) { return; }

      this.box = this.querySelector('[data-ms-lz-box]');
      this.picker = (this.closest('.product-form') || document).querySelector('.product-form__variants');
      if (!this.picker || !this.box) return;

      var T = this.txt;
      this.data.optionen.forEach(function (opt) {
        opt.werte.forEach(function (w) { w.t = T(w.t); w.i = T(w.i); w.st = T(w.st); });
      });

      this.byId = this.data.optionen.map(function (opt) {
        var m = {};
        opt.werte.forEach(function (w) { m[w.i] = w.t; });
        return m;
      });
      this.byText = this.data.optionen.map(function (opt) {
        var m = {};
        opt.werte.forEach(function (w) { m[w.t] = w.i; });
        return m;
      });
      this.stilFuer = this.data.optionen.map(function (opt) {
        var m = {};
        opt.werte.forEach(function (w) { m[w.t] = w.st; });
        return m;
      });

      var self = this;
      this._tick = null;
      this._letztesHtml = null;
      this._obsOpts = {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['checked', 'value', 'aria-checked', 'aria-selected', 'aria-expanded', 'class']
      };
      this._schedule = function () {
        clearTimeout(self._tick);
        self._tick = setTimeout(function () { self.update(); }, 40);
      };

      this._observer = new MutationObserver(this._schedule);
      this.beobachte();
      this.picker.addEventListener('change', this._schedule);

      this.update();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this.picker && this._schedule) this.picker.removeEventListener('change', this._schedule);
      clearTimeout(this._tick);
    }

    beobachte() {
      if (this._observer && this.picker) this._observer.observe(this.picker, this._obsOpts);
    }

    txt(x) {
      if (x === null || x === undefined) return '';
      if (typeof x === 'object') return String(x.name || x.title || x.value || x.id || '');
      return String(x);
    }

    norm(s) {
      return String(s || '').toLowerCase().replace(/\s+/g, '').replace(/[×*]/g, 'x');
    }

    esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    selektoren() {
      return this.picker.querySelectorAll('.product-form__option-selector');
    }

    currentOptions() {
      var self = this;
      var out = [];
      this.selektoren().forEach(function (sel, i) {
        var text = null;
        var input = sel.querySelector('input[type="radio"]:checked')
                 || sel.querySelector('input[type="hidden"][name^="option"]')
                 || sel.querySelector('input[name^="option"]');
        if (input && self.byId[i]) text = self.byId[i][self.txt(input.value)];
        if (!text) {
          var shown = sel.querySelector('.product-form__option-value, .select__selected-value');
          text = shown ? shown.textContent.trim() : null;
        }
        out.push(text);
      });
      return out;
    }

    findVariant(opts) {
      return this.data.varianten.find(function (v) {
        if (v.o.length !== opts.length) return false;
        return v.o.every(function (val, i) { return opts[i] == null || val === opts[i]; });
      }) || null;
    }

    wochen(tage) {
      var a = Math.floor(tage / 7);
      if (a <= 1) return 'ca. 1–2 Wochen';
      return 'ca. ' + a + '–' + (a + 1) + ' Wochen';
    }

    geld(cent) {
      try {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cent / 100);
      } catch (e) {
        return (cent / 100).toFixed(2) + ' €';
      }
    }

    preisText(diff) {
      if (diff === 0) return 'gleicher Preis';
      return (diff > 0 ? '+ ' : '− ') + this.geld(Math.abs(diff));
    }

    puckStil(zielOpts) {
      var self = this;
      var stil = '';
      this.data.optionen.forEach(function (opt, i) {
        if (opt.fix || stil) return;
        var s = self.stilFuer[i] ? self.stilFuer[i][zielOpts[i]] : null;
        if (s) stil = s;
      });
      return stil;
    }

    groessenKey(opts) {
      var self = this;
      var teile = [];
      this.data.optionen.forEach(function (opt, i) {
        if (opt.fix && opts[i]) teile.push(self.norm(opts[i]));
      });
      return teile.join('|');
    }

    farbKey(opts) {
      var self = this;
      var teile = [];
      this.data.optionen.forEach(function (opt, i) {
        if (!opt.fix && opts[i]) teile.push(self.norm(opts[i]));
      });
      return teile.join('|');
    }

    teilText(opts, fix) {
      return this.data.optionen.map(function (o, i) { return o.fix === fix ? opts[i] : null; })
                               .filter(Boolean).join(' · ');
    }

    /* Schluessel einer Ersatzmodell-Variante: ep.fix listet die Groessen-Indizes */
    ersatzKey(ep, ev, fixTeil) {
      var self = this;
      var teile = [];
      ev.o.forEach(function (val, idx) {
        var istFix = (ep.fix || []).indexOf(idx) !== -1;
        if (istFix === fixTeil) teile.push(self.norm(val));
      });
      return teile.join('|');
    }

    farbAlternativen(opts) {
      var self = this;
      var treffer = this.data.varianten.filter(function (v) {
        if (!v.verf || v.tage >= self.data.schwelle || v.tage <= 0) return false;
        var abweichung = 0;
        for (var i = 0; i < v.o.length; i++) {
          var fix = self.data.optionen[i] && self.data.optionen[i].fix;
          if (v.o[i] !== opts[i]) {
            if (fix) return false;
            abweichung++;
          }
        }
        return abweichung > 0;
      });
      treffer.sort(function (a, b) { return (a.tage - b.tage) || (a.preis - b.preis); });
      return treffer.slice(0, 3);
    }

    /* nurWunschfarbe = true: nur Modelle, die die gewaehlte Farbe fuehren */
    modellAlternativen(opts, nurWunschfarbe) {
      var self = this;
      var gk = this.groessenKey(opts);
      var fk = this.farbKey(opts);
      if (!gk) return [];

      var out = [];
      (this.data.ersatz || []).forEach(function (ep) {
        var passend = (ep.v || []).filter(function (ev) {
          if (self.ersatzKey(ep, ev, true) !== gk) return false;
          if (nurWunschfarbe && self.ersatzKey(ep, ev, false) !== fk) return false;
          return true;
        });
        if (!passend.length) return;

        passend.sort(function (a, b) {
          var af = self.ersatzKey(ep, a, false) === fk ? 0 : 1;
          var bf = self.ersatzKey(ep, b, false) === fk ? 0 : 1;
          return (af - bf) || (a.tage - b.tage) || (a.preis - b.preis);
        });

        out.push({
          modell: ep,
          variante: passend[0],
          wunschfarbe: self.ersatzKey(ep, passend[0], false) === fk
        });
      });

      out.sort(function (a, b) {
        return (a.wunschfarbe === b.wunschfarbe ? 0 : (a.wunschfarbe ? -1 : 1))
            || (a.variante.tage - b.variante.tage)
            || (a.variante.preis - b.variante.preis);
      });
      return out;
    }

    farbChip(v, current) {
      var self = this;
      var namen = v.o.filter(function (val, i) {
        return !(self.data.optionen[i] && self.data.optionen[i].fix);
      }).join(' · ');

      return '<a class="ms-lz-chip" data-ms-lz-vid="' + v.vid + '" href="'
        + this.esc(this.data.url + '?variant=' + v.vid) + '">'
        + '<span class="ms-lz-chip__puck" style="' + this.esc(this.puckStil(v.o)) + '"></span>'
        + '<span class="ms-lz-chip__label">'
        + '<span class="ms-lz-chip__name">' + this.esc(namen) + '</span>'
        + '<span class="ms-lz-chip__time">' + this.wochen(v.tage) + '</span>'
        + '<span class="ms-lz-chip__price">' + this.esc(this.preisText(v.preis - current.preis)) + '</span>'
        + '</span></a>';
    }

    modellChip(m, current) {
      var bild = m.modell.b ? 'background-image:url(' + m.modell.b + ')' : '';
      return '<a class="ms-lz-chip ms-lz-chip--modell" href="'
        + this.esc(m.modell.u + '?variant=' + m.variante.vid) + '">'
        + '<span class="ms-lz-chip__puck" style="' + this.esc(bild) + '"></span>'
        + '<span class="ms-lz-chip__label">'
        + '<span class="ms-lz-chip__name">' + this.esc(m.modell.t) + '</span>'
        + '<span class="ms-lz-chip__time">' + this.wochen(m.variante.tage) + '</span>'
        + '<span class="ms-lz-chip__price">' + this.esc(this.preisText(m.variante.preis - current.preis)) + '</span>'
        + '</span></a>';
    }

    update() {
      var self = this;
      var opts = this.currentOptions();
      var current = this.findVariant(opts);

      this.markSwatches(opts);

      if (!current || current.tage < this.data.schwelle) { this.setBox(''); return; }

      var groesse = this.teilText(opts, true);
      var farbe = this.teilText(opts, false);
      var farben = this.farbAlternativen(opts);
      var html = '';

      if (farben.length) {
        html = '<div class="ms-lz-box">'
          + '<p class="ms-lz-box__title">Schneller bei dir</p>'
          + '<p class="ms-lz-box__text">Dieses Modell'
          + (groesse ? ' in ' + this.esc(groesse) : '')
          + ' gibt es auch mit kurzer Lieferzeit:</p><div class="ms-lz-chips">';

        farben.forEach(function (v) { html += self.farbChip(v, current); });
        html += '</div>';

        var extra = this.modellAlternativen(opts, true)[0];
        if (extra) {
          html += '<p class="ms-lz-box__split">Du willst bei '
            + (farbe ? this.esc(farbe) : 'deiner Farbe')
            + ' bleiben? Dieses Bett gibt es in '
            + (farbe ? this.esc(farbe) : 'der Farbe')
            + (groesse ? ', ' + this.esc(groesse) : '')
            + ':</p><div class="ms-lz-chips">'
            + this.modellChip(extra, current)
            + '</div>';
        }

        html += '<p class="ms-lz-box__note">Ein Klick wechselt die Auswahl.</p></div>';
        this.setBox(html);
        return;
      }

      var modelle = this.modellAlternativen(opts, false).slice(0, 3);
      if (!modelle.length) { this.setBox(''); return; }

      html = '<div class="ms-lz-box">'
        + '<p class="ms-lz-box__title">Schneller bei dir</p>'
        + '<p class="ms-lz-box__text">In'
        + (groesse ? ' ' + this.esc(groesse) : ' dieser Größe')
        + ' dauert dieses Bett länger. Diese Modelle sind in derselben Größe kurzfristig lieferbar:'
        + '</p><div class="ms-lz-chips">';

      modelle.forEach(function (m) { html += self.modellChip(m, current); });
      html += '</div><p class="ms-lz-box__note">Gleiche Größe, anderes Modell.</p></div>';
      this.setBox(html);
    }

    setBox(html) {
      if (this._letztesHtml === html) return;
      this._letztesHtml = html;
      this.box.innerHTML = html;
      this.bindeChips();
    }

    bindeChips() {
      var self = this;
      this.box.querySelectorAll('.ms-lz-chip[data-ms-lz-vid]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

          var vid = a.getAttribute('data-ms-lz-vid');
          var ziel = self.data.varianten.find(function (v) { return String(v.vid) === String(vid); });
          if (!ziel) return;

          if (!self.select(ziel.o)) return;
          e.preventDefault();

          var link = a.getAttribute('href');
          setTimeout(function () {
            if (self.currentOptions().join('') !== ziel.o.join('')) {
              window.location.href = link;
            }
          }, 800);
        });
      });
    }

    select(zielOpts) {
      var self = this;
      var aktuell = this.currentOptions();
      var offen = 0;
      var erledigt = 0;

      this.selektoren().forEach(function (sel, i) {
        if (aktuell[i] === zielOpts[i]) return;
        offen++;

        var id = self.byText[i] ? self.byText[i][zielOpts[i]] : null;

        if (id) {
          var radio = sel.querySelector('input[type="radio"][value="' + id + '"]');
          if (radio) { radio.click(); erledigt++; return; }
          var option = sel.querySelector('[role="option"][value="' + id + '"]');
          if (option) { option.click(); erledigt++; return; }
        }

        if (self.selectByText(sel, zielOpts[i])) { erledigt++; return; }
      });

      return offen > 0 && offen === erledigt;
    }

    selectByText(sel, wunsch) {
      if (!wunsch) return false;
      var n = function (s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
      var ziel = n(wunsch);

      var radios = sel.querySelectorAll('input[type="radio"]');
      for (var k = 0; k < radios.length; k++) {
        var lab = radios[k].id ? sel.querySelector('label[for="' + radios[k].id + '"]') : null;
        var t = radios[k].getAttribute('aria-label') || (lab ? lab.textContent : '');
        if (n(t) === ziel) { radios[k].click(); return true; }
      }

      var optionen = sel.querySelectorAll('[role="option"]');
      for (var m = 0; m < optionen.length; m++) {
        if (n(optionen[m].textContent) === ziel) { optionen[m].click(); return true; }
      }

      return false;
    }

    markSwatches(opts) {
      var self = this;
      if (this._observer) this._observer.disconnect();

      try {
        this.selektoren().forEach(function (sel, i) {
          var swatches = sel.querySelectorAll('.color-swatch');
          if (!swatches.length) return;
          if (self.data.optionen[i] && self.data.optionen[i].fix) return;

          swatches.forEach(function (sw, j) {
            var wert = self.data.optionen[i] && self.data.optionen[i].werte[j];
            if (!wert) return;
            var probe = opts.slice();
            probe[i] = wert.t;
            var v = self.findVariant(probe);

            if (!v || !v.verf || !v.tage) {
              if (sw.hasAttribute('data-ms-lz')) sw.removeAttribute('data-ms-lz');
              return;
            }
            var neu = v.tage >= self.data.schwelle ? 'slow' : 'ok';
            if (sw.getAttribute('data-ms-lz') !== neu) sw.setAttribute('data-ms-lz', neu);
          });
        });
      } finally {
        this.beobachte();
      }
    }
  });
}
